var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckVerifiedCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0026 20.5007L18.3359 23.834L25.8359 16.334M12.2256 6.86514C13.5653 6.75823 14.8371 6.23141 15.8601 5.35968C18.2471 3.32542 21.7581 3.32542 24.1452 5.35968C25.1681 6.23141 26.4399 6.75823 27.7797 6.86514C30.906 7.11463 33.3886 9.59723 33.6381 12.7236C33.745 14.0633 34.2718 15.3352 35.1436 16.3581C37.1778 18.7452 37.1778 22.2561 35.1436 24.6432C34.2718 25.6661 33.745 26.938 33.6381 28.2777C33.3886 31.4041 30.906 33.8867 27.7797 34.1362C26.4399 34.2431 25.1681 34.7699 24.1452 35.6416C21.7581 37.6759 18.2471 37.6759 15.8601 35.6416C14.8371 34.7699 13.5653 34.2431 12.2256 34.1362C9.09918 33.8867 6.61658 31.4041 6.3671 28.2777C6.26019 26.938 5.73337 25.6661 4.86164 24.6432C2.82737 22.2561 2.82737 18.7452 4.86164 16.3581C5.73337 15.3352 6.26019 14.0633 6.3671 12.7236C6.61658 9.59723 9.09918 7.11463 12.2256 6.86514Z",
    stroke: "url(#paint0_linear_2763_27432)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2763_27432",
    x1: 3.33594,
    y1: 3.83398,
    x2: 37.7139,
    y2: 4.94863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C3AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B135CC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVerifiedCloud);
export default __webpack_public_path__ + "static/media/checkVerifiedCloud.af936b25cb9ec692f31cda0f70d29ad0.svg";
export { ForwardRef as ReactComponent };